export const AGORA_APP_ID = "08b0ca693b4944ef9ff4dee1a8fec99f";

// Keep token server awake
setInterval(() => {
  fetch('https://delrn-token-server.onrender.com/')
    .catch(() => {});
}, 14 * 60 * 1000); // ping every 14 minutes

export async function generateToken(channelName) {
  const response = await fetch(
    `https://delrn-token-server.onrender.com/token?channel=${channelName}`
  );
  const data = await response.json();
  return data.token;
}